import s from '@/shared/styles/policyTabs.module.css'

export function TabButton({ label, active, disabled, hint, onClick }: {
  label: string; active: boolean; disabled?: boolean; hint?: string; onClick: () => void
}) {
  return (
    <button
      role="tab"
      aria-selected={active}
      disabled={disabled}
      className={`${s.tab} ${active ? s.tabActive : ''}`}
      onClick={onClick}
    >
      {label}
      {hint && <span className={s.tabHint}>{hint}</span>}
    </button>
  )
}
